import { Box, Text } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onSelect: (value: string) => void
}

const fullNameTitleByCategory = (category?: string) => {
  switch (category) {
    case 'onboarding':
      return i18n.t('processes.process_settings.actions.automatic_email.variable.onboarding')
    case 'offboarding':
      return i18n.t('processes.process_settings.actions.automatic_email.variable.offboarding')
    default:
      return i18n.t('processes.process_settings.actions.automatic_email.variable.custom')
  }
}

export const VariablesSelectorComponent = ({ onSelect }: Props) => {
  const { category } = useStrictParams<string>()

  const variablesOptions: { id: string; label: string }[] = [
    {
      id: 'employee_name',
      label: fullNameTitleByCategory(category),
    },
    {
      id: 'manager_name',
      label: i18n.t('processes.process_settings.actions.automatic_email.variable.manager'),
    },
    {
      id: 'job_title',
      label: i18n.t('processes.process_settings.actions.automatic_email.variable.job_title'),
    },
    {
      id: 'contract_start_date',
      label: i18n.t(
        'processes.process_settings.actions.automatic_email.variable.contract_start_date'
      ),
    },
    {
      id: 'legal_entity',
      label: i18n.t('processes.process_settings.actions.automatic_email.variable.legal_entity'),
    },
  ]

  return (
    <Box padding="s0" flexDirection="row" justifyContent="flexEnd" paddingRight="s16">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Text.Normal color="viridian1200" size="200" weight="medium">
            + {i18n.t('processes.process_settings.actions.automatic_email.variables')}
          </Text.Normal>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {variablesOptions.map((option) => (
            <PopoverMenu.TouchableOption
              title={option.label}
              onClick={() => onSelect(option.id)}
              key={option.id}
            />
          ))}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
